module.exports = __webpack_public_path__ + "static/media/Week 3 Wednesday.bfb52c2d.png";